export namespace TextUtils {
  export function normalize(value: string) {
    const text = `${value || ''}`;
    return text
      .replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec))
      .replace(/(&.+;)/ig, (match, dec) => String.fromCharCode(match.charCodeAt(0)));
  }

  export function prettyPrint(value: any): string {
    const text = `${value || ''}`;
    return text
      .trim()
      // insert a space before all caps
      .replace(/([A-Z])/g, ' $1')
      // uppercase the first character
      .replace(/^./, (str) => str.toUpperCase())
      // cleanup spaces
      .trim();
  }

  export function parseEmails(values: string): string[] {
    return values.split(',')
      .map((v) => v.trim())
      .filter((v) => !!v);
  }
  
  export function validateEmail(email: string): boolean {
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
  }
}
